import { api } from "../api/Middleware";
import { WHITELABEL_CONFIG_URL } from "../api/Urls";

export const WhitelabelServices = {
  getConfig: async () => {
    try {
      console.log("🔍 Iniciando busca whitelabel para domínio:", window.location.hostname);
      console.log("📡 Chamando URL:", WHITELABEL_CONFIG_URL);
      
      const response = await api.get(WHITELABEL_CONFIG_URL);
      
      console.log("✅ Resposta whitelabel recebida:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Erro ao buscar configurações whitelabel:", error);
      console.log("🔄 Usando configuração padrão");
      return { is_whitelabel: false };
    }
  },

  isWhitelabel: (config) => {
    return config && config.is_whitelabel === true;
  },

  // Branding só é acessível quando a organização é whitelabel ativo
  // (is_whitelabel === true). Para contas sem whitelabel ativo, o frontend
  // continua mostrando o branding padrão da Mercado Agentes — mesmo após
  // o usuário ter cadastrado logo/cores via tela de Personalização.
  getBranding: (config) => {
    if (!WhitelabelServices.isWhitelabel(config)) {
      return null;
    }
    return config.branding || {};
  },

  getColors: (config) => {
    const branding = WhitelabelServices.getBranding(config);
    return branding?.colors || {};
  },

  getLogos: (config) => {
    const branding = WhitelabelServices.getBranding(config);
    return branding?.logo || {};
  },

  getBrandName: (config) => {
    const branding = WhitelabelServices.getBranding(config);
    return branding?.brand_name || "Mercado Agentes";
  },

  getOrganizationName: (config) => {
    if (!WhitelabelServices.isWhitelabel(config)) {
      return "Mercado Agentes";
    }
    return config.organization_name || "Mercado Agentes";
  },
};